<template>
  <h1
    v-if="shouldShowH1"
    class="screen-reader-only"
  >
    {{ title }}
  </h1>
</template>

<script>

export default {
  name: 'SeoH1',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      hasH1Element: false
    }
  },
  computed: {
    shouldShowH1 () {
      return !this.hasH1Element && this.title
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.checkForExistingH1()
      this.setupMutationObserver()
    })
  },
  beforeUnmount () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupMutationObserver () {
      this.observer = new MutationObserver((mutations) => {
        const hasH1Change = mutations.some(mutation =>
          Array.from(mutation.addedNodes).some(node =>
            node.nodeName === 'H1' ||
          (node.querySelectorAll && node.querySelectorAll('h1').length > 0)
          )
        )
        if (hasH1Change) {
          this.checkForExistingH1()
        }
      })
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    },
    checkForExistingH1 () {
      const h1Elements = document.querySelectorAll('h1:not(.screen-reader-only)')
      this.hasH1Element = _.size(h1Elements) > 0
      if (this.hasH1Element && this.observer) {
        this.observer.disconnect()
      }
    }
  }
}
</script>
